module.exports = "/bundle/icons.woff";